import DocViewer, { DocViewerRenderers } from '@cyntler/react-doc-viewer';
import { Dialog, DialogContent } from '@mui/material';
import { FC, memo, useEffect, useState } from 'react';

type PreviewFileModalProps = {
  filePath: string | null;
  handleClose: () => void;
  addS3Path?: boolean;
  isS3Path?: boolean;
};

const PreviewFileModal: FC<PreviewFileModalProps> = ({ addS3Path, isS3Path, filePath, handleClose }) => {
  const [showFilePath, setShowFilePath] = useState(filePath);
  const [fileExtensionName, setfileExtensionName] = useState<string | null>(null);
  // Extract the file extension

  useEffect(() => {
    setShowFilePath(filePath);
    if (filePath && isS3Path) {
      const fileName = filePath ? filePath?.split('/')?.pop()?.split('?')?.[0] : null;
      const fileExtension = fileName && fileName?.split('.')?.pop();
      if (fileExtension) {
        setfileExtensionName(fileExtension)
      }
    }
  }, [filePath])

  if (!filePath) {
    return null;
  }


  return (
    <Dialog open onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogContent>
        <DocViewer
          prefetchMethod="GET"
          documents={[
            {
              uri: !addS3Path ? import.meta.env.VITE_S3_PATH + showFilePath : showFilePath,
              ...(isS3Path && fileExtensionName ? { fileType: fileExtensionName } : {}),
            },
          ]}
          pluginRenderers={DocViewerRenderers}
          config={{
            header: { disableHeader: true },
          }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default memo(PreviewFileModal);
